module.exports = __webpack_public_path__ + "static/d-JGonzalez-070213a43608b9406b1d903c383bc5ad.jpg";